class StockIndicator extends HTMLElement {
  #host = null;
  #textEl = null;
  #variantsStock = {};
  #lowThreshold = 10;

  connectedCallback() {
    this.#host = this.closest('main-product');
    this.#textEl = this.querySelector('[data-stock-text]');
    this.#variantsStock = this.#parseStockData();
    this.#lowThreshold = parseInt(this.dataset.lowThreshold, 10) || 10;

    this.#host?.addEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#host?.removeEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  #parseStockData() {
    const node = this.querySelector('[data-variants-stock]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      console.error('stock-indicator: variants stock JSON parse failed', err);
      return {};
    }
  }

  #onVariantUpdate = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const stock = this.#variantsStock[String(variant.id)] || this.#variantsStock[variant.id];

    // out if unavailable; low only when tracked inventory is > 0 and <= threshold.
    // Overselling variants (continue-selling, qty 0 or negative) stay 'in' - still
    // purchasable - rather than 'low'.
    let state = 'in';
    if (variant.available === false || (stock && stock.available === false)) {
      state = 'out';
    } else if (stock && stock.inventory_quantity !== null && stock.inventory_quantity > 0 && stock.inventory_quantity <= this.#lowThreshold) {
      state = 'low';
    }

    this.#applyState(state);
  };

  #applyState(state) {
    this.dataset.state = state;

    const textKey = state === 'out' ? 'textOut' : state === 'low' ? 'textLow' : 'textIn';

    if (this.#textEl) {
      this.#textEl.textContent = this.dataset[textKey] || '';
    }
  }
}

if (!customElements.get('stock-indicator')) {
  customElements.define('stock-indicator', StockIndicator);
}
